import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {submitStep} from "../../network";
import {createConditionalRequire} from '../../utils';
import ReactGA from "react-ga";


const StudentProfiles = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/studentProfiles");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const {register, handleSubmit, errors, getValues} = useForm();
    const onSubmit = data => {
        setLoading(true)
        submitStep("student profiles", data)
            .then(() => {
                setLoading(false)
                nextStep()
            })
    };
    return (<>
        <Header title="Mismoodi me oleme abiks erineva programeerimiskogemusega tudengitele?"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">
            <div className="container">
                <p className="text">
                    Algkursust võtab päris suur hulk tudengeid, kellest mõnel on juba kogemus programmeerimise ja IT-ga,
                    aga paljudel ei ole.
                </p>
                <p className="text">
                    Oleme arvestanud teie kõigiga - meil on päris mitu toetavat süsteemi, kui oled päris algaja, aga
                    pakume väljakutseid ka neile, kes on juba programmeerimisega sina peal.
                </p>
                <p className="text">
                    Videos räägib abiõppejõud Nele Lasn sellest, mida pakume erineva IT-kogemusega tudengitele, ja
                    pärast küsime Sult, millise kogemusega gruppi Sa ennast kuuluvaks pead.
                </p>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/aN63zyI64Ow?showinfo=0" frameBorder="0"
                            allowFullScreen></iframe>
                </figure>
                <p className="text">
                    Kui nüüd tunned, et Sul oleks abi täiendusõppe ainest, hoia silma peal aine Discordi serveril, kus
                    peagi selle kohta infot jagame!
                </p>
            </div>
            <form className="container" onSubmit={handleSubmit(onSubmit)}>
                <h1 className="subtitle form-question">
                    Milline on hetkel Sinu IT-alane kogemus?
                </h1>
                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer"
                               value="No previous experience"/>
                        Ma ei ole enne IT-ga eriti kokku puutunud. Olen arvutit kasutanud, et kasutada sotsiaalmeediat,
                        lugeda uudiseid ja teha koolitöid.
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="Minimal experience"/>
                        Olen arvutiga rohkem sina peal. Näiteks olen aidanud vanaemal printerit seadistada, mänginud
                        hulgaliselt arvutimänge või endale arvuti ehitanud.
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="Some IT experience"/>
                        Olen tööl IT-s (või olen töötanud), kuid mitte tarkvaraarendajana või olen muul moel
                        programmeerimisega mingil määral kokku puutunud - näiteks läbinud mõne programmeerimiskursuse.
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer"
                               value="Experience as a software engineer"/>
                        Töötan või olen töötanud programmeerijana, tulin ülikooli diplomit saama või juurde õppima.
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="Do not want to answer"/>
                        Ei taha või ei oska praegu vastata
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="problem"/>
                        Minuga on natuke teine lugu, mida võiksite teada (palun kirjuta kommentaar).
                        <input name="answerProblem"
                               ref={register(createConditionalRequire(getValues, "answer", "problem"))}
                               className="input" type="text"/>
                    </label>
                </div>


                {Object.keys(errors).length ? <div className="validation-error">
                    Jätkamiseks vasta palun kõigile küsimustele!
                </div> : null}
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`}
                        disabled={isLoading}>JÄRGMINE →
                </button>
            </form>
        </section>
    </>);
};

export default StudentProfiles;
